"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var api_internal_contract_js_1 = require("@tableau/api-internal-contract-js");
var ServiceImplBase_1 = require("./ServiceImplBase");
var StoryActivationServiceImpl = /** @class */ (function (_super) {
    __extends(StoryActivationServiceImpl, _super);
    function StoryActivationServiceImpl() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(StoryActivationServiceImpl.prototype, "serviceName", {
        get: function () {
            return "story-activation-service" /* StoryActivation */;
        },
        enumerable: true,
        configurable: true
    });
    StoryActivationServiceImpl.prototype.activateNextStoryPointAsync = function () {
        var _a;
        var verb = api_internal_contract_js_1.VerbId.ActivateNextStoryPoint;
        var parameters = (_a = {},
            _a[api_internal_contract_js_1.ParameterId.FunctionName] = 'activateNextStoryPointAsync',
            _a);
        return this.execute(verb, parameters).then(function (response) {
            return;
        });
    };
    StoryActivationServiceImpl.prototype.activatePreviousStoryPointAsync = function () {
        var _a;
        var verb = api_internal_contract_js_1.VerbId.ActivatePreviousStoryPoint;
        var parameters = (_a = {},
            _a[api_internal_contract_js_1.ParameterId.FunctionName] = 'activatePreviousStoryPointAsync',
            _a);
        return this.execute(verb, parameters).then(function (response) {
            return;
        });
    };
    StoryActivationServiceImpl.prototype.activateStoryPointAsync = function (index) {
        var _a;
        var verb = api_internal_contract_js_1.VerbId.ActivateStoryPoint;
        var parameters = (_a = {},
            _a[api_internal_contract_js_1.ParameterId.FunctionName] = 'activateStoryPointAsync',
            _a);
        parameters[api_internal_contract_js_1.ParameterId.StoryPointIndex] = index;
        return this.execute(verb, parameters).then(function (response) {
            return;
        });
    };
    StoryActivationServiceImpl.prototype.revertStoryPointAsync = function (index) {
        var _a;
        var verb = api_internal_contract_js_1.VerbId.RevertStoryPoint;
        var parameters = (_a = {},
            _a[api_internal_contract_js_1.ParameterId.FunctionName] = 'revertStoryPointAsync',
            _a);
        parameters[api_internal_contract_js_1.ParameterId.StoryPointIndex] = index;
        return this.execute(verb, parameters).then(function (response) {
            return response.result;
        });
    };
    return StoryActivationServiceImpl;
}(ServiceImplBase_1.ServiceImplBase));
exports.StoryActivationServiceImpl = StoryActivationServiceImpl;
//# sourceMappingURL=StoryActivationServiceImpl.js.map